import React from 'react';
import { Row, Button, Space, Alert, Card, Image, Col } from 'antd';

import Vehicle from '../../../core/models/Vehicle';

interface IProps {
  vehicle: Vehicle | null;
}

const ViewVehicleInspection: React.FC<IProps> = ({ vehicle }: IProps) => {
  return (
    <>
      <Row>
        <Space>
          {!vehicle?.inspectionReportUrl && (
            <Alert message='Grading Report is not available.' type='warning' />
          )}
          {vehicle?.inspectionReportUrl && (
            <Row>
              <Col>
                <Button type='link' href={vehicle?.inspectionReportUrl} target='_blank'>
                  View Grading Report in Full Screen
                </Button>
                <br />
                <iframe
                  width={600}
                  height={860}
                  src={`${vehicle?.inspectionReportUrl}?view=fitH`}
                ></iframe>
              </Col>
            </Row>
          )}
        </Space>
      </Row>
    </>
  );
};

export default ViewVehicleInspection;
